import React from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { ButtonLinkProps } from "@/types/ui";

export const ButtonLink = ({
  children,
  href,
  variant = "default",
  size = "default",
  className,
  external = false,
  ...props
}: ButtonLinkProps) => {
  const baseStyles =
    "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variants = {
    default: "bg-orange-500 text-white hover:bg-orange-600",
    outline:
      "border-2 border-white text-white hover:bg-white hover:text-gray-900",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline",
    destructive:
      "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10",
  };

  const linkProps = external
    ? { href, target: "_blank", rel: "noopener noreferrer" }
    : { href };

  return (
    <Link
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      {...linkProps}
      {...props}
    >
      {children}
    </Link>
  );
};
